<template>
    <el-dialog :visible.sync="dialogData.visible" :width="dialogData.width" :before-close="dialogClose"
      :close-on-click-modal="dialogData.modal">
      <!--  弹框的标题  -->
      <div slot="title" class="dialogTitle">{{ dialogData.title }}</div>
      <!--  弹框主题内容  -->
      <div class="dialog-content" v-loading="dialogData.isLoading" :element-loading-text="dialogData.loading_text"
        element-loading-spinner="el-icon-loading">
        <div>
          <el-form :inline="true" :model="searchCondition">
  
            <el-form-item :required="item.required" class="elformItem" v-for="(item,index) in comData"
              :label="item.type=='button'?'':item.label" :key="index">
              <el-select :filterable="item.filterable" clearable @change="event_change(item)" v-if="item.type=='select'"
                :placeholder="item.placeholder?item.placeholder:item.label" v-model="item.val">
                <el-option v-for="(item_type,index_type) in item.typeData" :label="item_type.label" :value="item_type.val"
                  :key="index_type"></el-option>
              </el-select>
              <el-switch v-if="item.type=='switch'" v-model="item.val">
              </el-switch>
  
            </el-form-item>
          </el-form>
  
          <div class="btn-class">
            <el-button @click="buttonTap('add')" type="primary">确定</el-button>
          </div>
  
        </div>
      </div>
    </el-dialog>
  
  </template>
  
  <script>
    export default {
      name: "Channel",
      props: {
        id: {
          type: String,
          default: ''
        },
        // 按钮组
        buttonArr: Array,
        //是否不可编辑
        cantEdit: {
          type: Boolean,
          default: false
        },
        //搜索条件源数据
        comData: Array,
        //对齐模式
        align: {
          type: String,
          default: 'left'
        },
        dialogData: {
          type: Object,
          default () {
            return {}
          }
        }
      },
      components: {
  
      },
      data() {
        return {
          searchCondition: {}
        }
      },
      mounted() {
      },
      methods: {
  
        // 处理函数
        event_change(item) {
  
          let obj = {}
          this.comData.map((item) => {
            obj[item.field] = item.val
            if (obj[item.field] === '' || obj[item.field] === undefined) {
              delete obj[item.field]
            }
          })
  
          this.searchCondition = obj
  
          if (item.field == 'settlement_id') {
            this.searchCondition.company_id = '';
            this.comData.map(item => {
              if (item.field === 'company_id') {
                item.val = ''
              }
            })
            this.$emit('allCompanyListEdit', this.searchCondition)
          }
        },
  
        buttonTap(e) {
          switch (e) {
            case 'add':
              var data = {}
              if (this.id) {
                data.id = this.id
              }
              var searchCondition = this.searchCondition;
              this.comData.map(item => {
                if (item.type == 'switch') {
                  searchCondition[item.field] = item.val ? '1' : '2'
                } else {
                  searchCondition[item.field] = item.val
                }
              })
              if (!searchCondition.company_id) {
                this.$message.error("请选择必选项")
                return;
              }
              data = {
                ...data,
                ...searchCondition
              }
              this.createBChannel(data)
              break;
            default:
              break;
          }
        },
  
        dialogClose() {
          this.$emit('dialogClose')
        },
        // 创建税源地
        async createBChannel(data) {
            console.log(data,'数据');
            console.log(this.dialogData.title,'弹框的数据');
            let result
            if(this.dialogData.title == '添加') {
                 result = await this.$api.post_esign_whiteList(data)
            } else if(this.dialogData.title == '修改') {
                let obj = {
                    company_id:data.company_id
                }
                result = await this.$api.update_esign_whiteList(data.id,obj)
            }
            if (result) {
                  this.$message.success("保存成功")
                  this.notifyInfo = {}
                  this.dialogClose()
                  this.$emit('dialogConfirm', true)
            }
        },
      },
      watch: {}
    }
  </script>
  
  <style lang="stylus" scoped>
    .dialogTitle {
      position: relative;
      padding-left: 10px;
      font-size: 16px;
      color: black;
      
    }
  
    .dialogTitle:before {
      position: absolute;
      width: 4px;
      height: 20px;
      content: "";
      background: #1890ff;
      left: 0;
      top: 0;
    }
  
    /deep/ .el-dialog__footer {
      text-align: center;
    }
    /deep/ .el-dialog__body {
        text-align: center;
    }
  
    .btn-class {
      display: flex;
      justify-content: center;
    }
  </style>
  